import React from "react";
import DefaultBlock from "../components/main/DefaultBlock";
import { Grid, Typography, Box } from "@mui/material";
import SkillCard from "../components/technologies/SkillCard";
import BlueprintBlock from "../components/main/BlueprintBlock";
import SEO from "../components/misc/SEO";

const skills = [
  {
    logoSrc: "/tech/react.webp",
    skillName: "React.js",
    description: "React is my primary frontend library when I design websites.",
    progress: 30,
  },
  {
    logoSrc: "/tech/ue.webp",
    skillName: "Unreal Engine",
    description: "Unreal Engine is my primary tool for making games.",
    progress: 70,
  },
  {
    logoSrc: "/tech/figma.svg",
    skillName: "Figma",
    description:
      "Figma is what I use for UI/UX designs, often paired with Adobe Illustrator.",
    progress: 65,
  },
  {
    logoSrc: "/tech/ps.svg",
    skillName: "Photoshop",
    description: "I am a certified Adobe Associate in Photoshop.",
    progress: 75,
  },
  {
    logoSrc: "/tech/ai.svg",
    skillName: "Illustrator",
    description:
      "I am a certified Adobe Associate in Illustrator, which I use for UI/UX designs.",
    progress: 75,
  },

  {
    logoSrc: "/tech/blender.png",
    skillName: "Blender",
    description:
      "I've been using Blender since 2011 to make 3D designs for many projects.",
    progress: 60,
  },
  {
    logoSrc: "/tech/git.svg",
    skillName: "Git",
    description:
      "Git is usually what I use for source control for web projects. I use Perforce for games.",
    progress: 40,
  },

  {
    logoSrc: "/tech/js.svg",
    skillName: "JavaScript",
    description:
      "I use Javascript for websites and sometimes I use it for games!",
    progress: 40,
  },
  {
    logoSrc: "/tech/node.png",
    skillName: "Node.js",
    description:
      "Node.js is what I use as the hub for all of my fullstack Javascript work.",
    progress: 25,
  },
];

export default function Technologies() {
  return (
    <div>
      <SEO
        title="Technologies | Aaron Hunt"
        description="Learn more about my favorite technologies and my experience with them!"
      />
      <BlueprintBlock text="export default function Technologies() {" />
      <DefaultBlock id="work-examples">
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Technologies
        </Typography>

        <Box className="backgroundGrid">
          <Grid
            container
            spacing={2}
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            {skills.map((skill, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <SkillCard {...skill} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </DefaultBlock>
    </div>
  );
}
